module.exports = __webpack_public_path__ + "img/button-secondary.827ea763.png";